import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditCompany = _resolveComponent("EditCompany")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_UserTable = _resolveComponent("UserTable")!
  const _component_ClientCompanies = _resolveComponent("ClientCompanies")!
  const _component_AccountingFirms = _resolveComponent("AccountingFirms")!
  const _component_AccountingWorkspaces = _resolveComponent("AccountingWorkspaces")!
  const _component_AccountingPeriods = _resolveComponent("AccountingPeriods")!
  const _component_BankConfig = _resolveComponent("BankConfig")!
  const _component_LegalForm = _resolveComponent("LegalForm")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.companyId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.type === 'company')
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_EditCompany, {
                          settingsMode: true,
                          adminMode: true,
                          companyId: _ctx.companyId,
                          showLogo: true
                        }, null, 8, ["companyId"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.type === 'users')
              ? (_openBlock(), _createBlock(_component_UserTable, {
                  key: 1,
                  title: 'Utilisateurs',
                  companyId: _ctx.companyId,
                  mode: undefined,
                  admin: true
                }, null, 8, ["companyId"]))
              : _createCommentVNode("", true),
            (_ctx.type === 'clients-companies')
              ? (_openBlock(), _createBlock(_component_ClientCompanies, {
                  key: 2,
                  onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh()))
                }))
              : _createCommentVNode("", true),
            (_ctx.type === 'accounting-firms')
              ? (_openBlock(), _createBlock(_component_AccountingFirms, {
                  key: 3,
                  accountingFirm: _ctx.company,
                  onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refresh()))
                }, null, 8, ["accountingFirm"]))
              : _createCommentVNode("", true),
            (_ctx.type === 'accounting-workspaces')
              ? (_openBlock(), _createBlock(_component_AccountingWorkspaces, {
                  key: 4,
                  accountingFirm: _ctx.company,
                  onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refresh()))
                }, null, 8, ["accountingFirm"]))
              : _createCommentVNode("", true),
            (_ctx.type === 'accounting-period')
              ? (_openBlock(), _createBlock(_component_AccountingPeriods, {
                  key: 5,
                  companyId: _ctx.companyId
                }, null, 8, ["companyId"]))
              : _createCommentVNode("", true),
            (_ctx.type === 'bank')
              ? (_openBlock(), _createBlock(_component_BankConfig, {
                  key: 6,
                  companyId: _ctx.companyId
                }, null, 8, ["companyId"]))
              : _createCommentVNode("", true),
            (_ctx.type === 'legal')
              ? (_openBlock(), _createBlock(_component_v_row, { key: 7 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "headline"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Mentions Légales ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_LegalForm, { companyId: _ctx.companyId }, null, 8, ["companyId"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, "Pas de société"))
    ]),
    _: 1
  }))
}